import { render, staticRenderFns } from "./kvDataDetail.vue?vue&type=template&id=2df23506&scoped=true"
import script from "./kvDataDetail.vue?vue&type=script&lang=js"
export * from "./kvDataDetail.vue?vue&type=script&lang=js"
import style0 from "./kvDataDetail.vue?vue&type=style&index=0&id=2df23506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df23506",
  null
  
)

export default component.exports